<template>
    <div class="relative rounded overflow-hidden aspect-ratio-16/9 bg-gray-400">
        <div v-if="src" :style="`background-image: url(${src})`" class="absolute inset-0 bg-cover"/>
        <div
            class="absolute bottom-0 left-0 bg-white w-12 h-12 inline-flex justify-center items-center">
            <font-awesome-icon icon="play"/>
        </div>
    </div>
</template>

<script>

import urlParser from "js-video-url-parser";

export default {

    props: {
        videoData: {
            type: Object,
        },
        videoSrc: {
            type: String,
        }
    },

    data() {
        return {
            src: ""
        };
    },

    mounted() {
        this.setSrc();
    },

    methods: {
        async setSrc() {
            if (_.get(this.videoData, 'thumbnail')) {
                this.src = _.get(this.videoData, 'thumbnail');
            } else if (this.videoSrc) {
                await this.setSrcFromVideoSrc();
            }
        },
        async setSrcFromVideoSrc() {
            let src = `https://img.youtube.com/vi/${this.source.id}/mqdefault.jpg`;

            if (_.get(this.source, 'provider') === 'vimeo') {

                const data = await axios.get(`https://vimeo.com/api/v2/video/${this.source.id}.json`, {
                    transformRequest: (data, headers) => {
                        delete headers.common['X-Requested-With'];
                    }
                });

                src = _.get(data, 'data.0.thumbnail_large', src);
            }

            this.src = src;
        },
    },
    computed: {
        source() {
            return urlParser.parse(this.videoSrc) || {};
        },
        alt() {
            if (_.has(this.source, 'provider') && ['youtube', 'vimeo'].includes(this.source.provider)) {
                return `${this.source.provider} video - ${this.source.id}`;
            }
        },
    },
    watch: {
        thumbnailSrc() {
            this.setSrc();
        },
        videoSrc() {
            this.setSrc();
        }
    },
};

</script>
